<div #itemDivs *ngFor="let item of items; index as index trackBy: trackByFn" class="item">
    <div class="p-inputgroup">
        <input type="text" [(ngModel)]="items[index]" pInputText (keypress)="keyPressed($event)">
        <button type="button" pButton class="delete-button" icon="fas fa-trash" (click)="removeItem(index)"></button>
    </div>
</div>
<p-button class="add-button" icon="fas fa-plus" [label]="addTitle" (click)="addItem()"></p-button>
